var moduleName = "services.format";

const $inject = [];

class FormatService {
  constructor() {
  }

  medicare(medicare_number) {
    medicare_number = medicare_number.replace(/^(\d{10})(\d)/, "$1/$2");
    medicare_number = medicare_number.replace(/^(\d{9})(\d)/, "$1 $2");
    medicare_number = medicare_number.replace(/^(\d{4})(\d)/, "$1 $2");
    return medicare_number;
  }

  phone(phone_number){
    phone_number = phone_number.replace(/^(04\d{5})(\d)/, "$1 $2");
    phone_number = phone_number.replace(/^(04\d\d)(\d)/, "$1 $2");
    phone_number = phone_number.replace(/^(0[^4\D]\d{4})(\d)/, "$1 $2");
    phone_number = phone_number.replace(/^(0[^4\D])(\d)/, "$1 $2");
    phone_number = phone_number.replace(/^([^0\D]\d{4})(\d)/, "$1 $2");
    return phone_number;
  }
}

FormatService.$inject = $inject;
//noinspection JSValidateTypes
export default angular.module(moduleName, [])
  .service("FormatService", FormatService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/format.service.js
 **/